// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3UTlf1KP8INVFh2mLtjKYb{aspect-ratio:16/9}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"aspectRatio": "_3UTlf1KP8INVFh2mLtjKYb"
};
module.exports = ___CSS_LOADER_EXPORT___;
